"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _modalActions = require("../actions/interactions/modalActions");

var _AsyncCreateNewBlogModalContainer = _interopRequireDefault(require("./modals/AsyncCreateNewBlogModalContainer"));

var _BlogSettingsEmptyState = _interopRequireDefault(require("../components/BlogSettingsEmptyState"));

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var BlogSettingsEmptyStateContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BlogSettingsEmptyStateContainer, _Component);

  function BlogSettingsEmptyStateContainer() {
    (0, _classCallCheck2.default)(this, BlogSettingsEmptyStateContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlogSettingsEmptyStateContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(BlogSettingsEmptyStateContainer, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(_BlogSettingsEmptyState.default, {
        onCreateBlog: this.props.openNewBlogModal,
        blogImporterRoute: this.props.blogImporterRoute
      }), _react.default.createElement(_AsyncCreateNewBlogModalContainer.default, null));
    }
  }]);
  return BlogSettingsEmptyStateContainer;
}(_react.Component);

BlogSettingsEmptyStateContainer.propTypes = {
  openNewBlogModal: _react.PropTypes.func.isRequired,
  blogImporterRoute: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  _Routes.default.init((0, _selectors.getUserGates)(state));

  return {
    blogImporterRoute: _Routes.default.blogImporter()
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  openNewBlogModal: _modalActions.openNewBlogModal
})(BlogSettingsEmptyStateContainer);

exports.default = _default;
module.exports = exports.default;